<template>
<div class="row">
  <div class="col s12">
  <div
    id="home-guide-tutorials-card"
    class="card waves-effect waves-block"
    @click="$_goToGuidesTutorials()"
  >
  <div class="card-content">
    <div class="icon">
     <img :src="resourceCentre" alt="Resource Centre">
    </div>
    <div class="info-container">
      <div class="title">Resource Centre</div>
      <div class="text">Access a collection of helpful resources from reputable sources to support you in completing your Climate Change Home Risk Assessment and Adaptation Plan! </div>
    </div>
  </div>
  </div>
    </div>
</div>
</template>
<script>
import resourceCentre from '@/assets/resource_centre.svg'
export default {
  name: "GuideTutorialsCard",
  props: {},
  data() {
    return {
      resourceCentre
    }
  },
  mounted() {},
  computed: {},
  methods: {
    $_goToGuidesTutorials() {
      this.$router.push({name:'resourceCenter'})
      ///console.log("Go to guides and tutorials page");
    },
  },
};
</script>
<style lang="scss" scoped>
#home-guide-tutorials-card {
  .card-content {
    display: flex;
    align-items: center;
    @media screen and (max-width:580px) {
      flex-wrap: wrap;
    }
    .icon {
      margin-right: 1rem;
      img {
        width: 64px;
      }
      i {
        font-size: 42px;
      }
      
    @media screen and (max-width:580px) {
      text-align: center;
      width: 100%;
      img {
        margin: 0px;
        width: 84px;
      }
     }
    }
    .title {
      font-size: 20px;
        @media screen and (max-width:580px) {
          margin-bottom: 8px;
           text-align: center;
        }
    }
  }
}
</style>
